import LowLeadsCritiqueView from './LowLeadsCritiqueView'
export default LowLeadsCritiqueView
